<template>
  <div ref="rootRef" class="dropdown tag-area" :class="{ show: isOpen }">
    <div
      class="btn--select"
      :aria-expanded="isOpen"
      @click="toggle"
    >
      <div class="btn--select-tags">
        <ButtonElement
            v-for="(item, index) in modelValue" :key="index"
            class="btn btn-default btn--ms btn--tag" @click="removeOption(item)">
          <span class="icon" v-if="item.svg">
              <img v-if="item.svg"
                   :src="(`${item?.svg}`)"/>
            </span>
          <span class="tag-title">
              {{ item.name }}
            </span>
          <span class="tag-remove">
              <X aria-hidden="true" />
            </span>
        </ButtonElement>
        <span class="btn--select-angle-down"><ChevronDown aria-hidden="true" /></span>
      </div>
    </div>

    <ul class="dropdown-menu" :class="{ show: isOpen }" id="tagAreaMenu" @click.stop="">
      <div v-if="filteredOption && filteredOption.length>0" class="dropdown-menu-box animation">
        <div class="dropdown-menu-head">{{ title }}</div>
        <div class="scrollbar" style="max-height:260px;overflow-y: auto">
          <li v-for="(option, index) in filteredOption" :key="index">
            <a
                @click="selectOption(option)"
                class="dropdown-item"
            >

               <img v-if="option.svg"
                   :src="(`${option?.svg}`)"/>

                <span>{{ option.name }}</span>

            </a>
          </li>
        </div>
      </div>
    </ul>
  </div>
</template>
<script setup lang="ts">
import { ChevronDown, X } from '@lucide/vue'
import {ref} from 'vue';
import type {DropdownNs} from '@shared/types';
import {useDropdown} from '@shared/composables/use-dropdown';
import {ButtonElement} from '@shared/components/elements';

const props = defineProps<{
  modelValue: DropdownNs.DropdownOptionsItem[];
  options:    DropdownNs.DropdownOptionsItem[];
  title?:     string;
  svg?:       DropdownNs.DropdownOptionsItem[];
}>();

const emit = defineEmits<{
  (e: 'change'): void;
  (e: 'update:modelValue', value: DropdownNs.DropdownOptionsItem[]): void;
}>();

const {isOpen, rootRef, toggle} = useDropdown();

const filteredOption = ref<DropdownNs.DropdownOptionsItem[]>(
  props.options.filter(item =>
    props.modelValue.findIndex(modelItem => modelItem.value === item.value) === -1,
  ),
);

function selectOption(option: DropdownNs.DropdownOptionsItem): void {
  const value = [...(props.modelValue || []), option];
  filteredOption.value = filteredOption.value.filter(item => item.value !== option.value);
  emit('update:modelValue', value);
  emit('change');
}

function removeOption(option: DropdownNs.DropdownOptionsItem): void {
  const value = props.modelValue.filter(item => item.value !== option.value);
  filteredOption.value = [...(filteredOption.value || []), option];
  emit('update:modelValue', value);
  emit('change');
}
</script>
<style lang="scss" scoped>
.dropdown {
  width: 100%;
  .dropdown-menu {
    width: 100%;


    &.dropdown-menu-large {
      width: 100%;
    }

    .dropdown-menu-box{
      min-width: 360px;
      padding: var(--space-16) var(--space-8) var(--space-8);
    }

    .dropdown-menu-list{
      padding: var(--space-8);
    }


    .dropdown-item {
      display: flex;
      align-items: center;
      gap: var(--space-8);
      padding: var(--space-8) var(--space-8);
      background-color: var(--transparent);
      border: 1px solid var(--transparent);
      font-size: var(--fs-14);
      border-radius: $br-sm;
      cursor: pointer;


      &:hover,
      &.active {
        background-color: var(--item-blue-bg-hover);
        border: 1px solid var(--item-blue-border-hover);
        .key{
          span{
            display: flex;
          }
        }
      }

      .icon {
        width: 30px;
        display: flex;
        align-items: center;
        margin: var(--space-0);
        color: var(--text-neutral);

        img {
          width: 20px;
          height: 20px;
        }
      }

      .content {
        flex: 1;
        h6 {
          margin: var(--space-0);
          font-size: var(--fs-14);
          font-weight: 500;
        }
        p {
          margin: var(--space-0);
          font-size: var(--fs-12);
          color: var(--text-neutral);
        }
      }
      .key{
        display: flex;
        width: 24px;
        height: 24px;
        span{
          display: none;
          justify-content: center;
          align-items: center;
          width: 24px;
          height: 24px;
          border-radius: $br-sm;
          font-size: var(--fs-12);
          color: var(--text-dark);
          background-color: var(--button-key-bg);
          border: 1px solid var(--button-key-border);
          border-bottom: 2px solid var(--button-key-border);
        }
      }
    }

    .create-item {
      .content{
        h6{
          font-weight: 400;
        }
      }

      &-tag{
        padding: var(--space-2) var(--space-4);
        background-color: var(--tag-create-bg);
        border: 1px solid var(--tag-create-border);
        border-radius: $br-xs;
        font-weight: 500;
        margin-left: var(--space-2);
      }
    }

    .no-results {
      padding: 10px;
      text-align: center;
      color: var(--text-neutral);
    }
  }
}


.btn--select{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-radius: $br-sm;
  background-color: var(--form-bg);
  border: 1px solid var(--form-border);
  box-shadow: none !important;
  gap: var(--space-4);
  padding: var(--space-4);
  position: relative;
  min-height: 42px;
  width: 100%;
  cursor: pointer;


  &:hover,
  &:focus,
  &:active {
    background-color: var(--form-bg-hover);
    border: 1px solid var(--form-border-hover);
    box-shadow: var(--form-shadow-outline) !important;
  }

  &:has(input:focus) {
    background-color: var(--form-bg-focus);
    border: 1px solid var(--form-border-focus);
    box-shadow: var(--form-shadow-outline) !important;
    .tag {
      background-color: var(--tag-form-bg-hover);
      border: 1px solid var(--tag-form-border-hover);
    }
  }

  &-tags {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
    font-size: var(--fs-14);
    padding: 0;
    width: 100%;
    position: relative;
    min-height: 27px;
  }

  &-angle-down {
    font-size: var(--fs-16);
    position: absolute;
    right: 10px;
    top: 3px;
  }
}
</style>
